"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const C64Layout_1 = require("./C64Layout");
class FLIPicture {
    constructor() {
        this.formatName = 'fli';
        this.defaultExtension = 'fli';
    }
    fromPixelImage(pixelImage) {
        this.loadAddress = new Uint8Array(2);
        this.loadAddress[0] = 0;
        this.loadAddress[1] = 0x3c;
        this.colorRam = C64Layout_1.default.convertColorram(pixelImage, 1);
        this.bitmap = C64Layout_1.default.convertBitmap(pixelImage);
        this.screenRam = [];
        for (let i = 0; i < 8; i += 1) {
            this.screenRam[i] = C64Layout_1.default.convertScreenram(pixelImage, 2, 3, i);
        }
        this.background = new Uint8Array(1);
        this.background[0] = pixelImage.colorMaps[0].get(0, 0);
    }
    toMemoryMap() {
        return [
            this.loadAddress,
            C64Layout_1.default.pad(this.colorRam, 24),
            C64Layout_1.default.pad(this.screenRam[0], 24),
            C64Layout_1.default.pad(this.screenRam[1], 24),
            C64Layout_1.default.pad(this.screenRam[2], 24),
            C64Layout_1.default.pad(this.screenRam[3], 24),
            C64Layout_1.default.pad(this.screenRam[4], 24),
            C64Layout_1.default.pad(this.screenRam[5], 24),
            C64Layout_1.default.pad(this.screenRam[6], 24),
            C64Layout_1.default.pad(this.screenRam[7], 24),
            this.bitmap,
            this.background
        ];
    }
}
exports.default = FLIPicture;
//# sourceMappingURL=FLIPicture.js.map